// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubTopicButton_wrapper__sGOl8","title":"SubTopicButton_title__SVtdM","description":"SubTopicButton_description__yc0A1"};